import { render } from "./_CompanySetting.vue?vue&type=template&id=38d29823"
import script from "./_CompanySetting.vue?vue&type=script&lang=js"
export * from "./_CompanySetting.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\32\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__